import React from 'react'
import styled from 'styled-components';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import {BackButton} from './BackButton';

const getBreadcrumb = (type, t) => {
  switch (type) {
    case 'story':
      return t('urls.story');
    case 'sleep':
      return t('urls.sleep');
    case 'community':
      return t('urls.community-story');
    case 'audiobook':
      return t('urls.audiobook');
    default:
      return '';
  }
};
const Index = ({type}) => {
  const { t } = useTranslation();

  return (
    <NavigationWrapper>
      <BackButton $absolute $marginTop $marginLeft $white/>
      <BreadcrumbWrapper>
        <Breadcrumb to={t('urls.root')}>Home</Breadcrumb>
        /
        <Breadcrumb to={getBreadcrumb(type, t)}>{type}</Breadcrumb>
      </BreadcrumbWrapper>
    </NavigationWrapper>
  )
}

export default Index


const NavigationWrapper = styled.div`
  display:flex;
  z-index: 9999;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  margin-top:30px;
  margin-left:30px;
  @media ${props => props.theme.phoneLand} {
    margin-top:25px;
    margin-left:25px;
  }
`

const BreadcrumbWrapper = styled.div`
  display:flex;
  align-items: center;
  gap: 5px;
  font-family: 'Poppins';
  color: white;
  font-size: 10px;
  margin-left:16px;

`

const Breadcrumb = styled(Link)`
  font-size: 16px;
  font-weight: 300;
  text-transform: uppercase;
  text-decoration: none;
  position: relative;
  color: white;
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0px;
    width: 100%;
    height: 2px;
    background-color: #F19D9A;
  }
`
